import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/loginContext";
import { FiBell, FiHelpCircle } from "react-icons/fi";
import "./header.css";

const TITLES_BY_PATH = {
  "/dashboard": "DASHBOARD",
  "/asistencia-campo": "CONTROL DE ASISTENCIA A CAMPO",
  "/asistencia-local": "ASISTENCIA LOCAL",
  "/agregar-usuario": "AGREGAR USUARIO",
  "/institution-notices": "GESTIONAR NOTIFICACIONES",
  "/location-maintenance": "MANTENIMIENTO DE LOCALES",
  "/boletas-firmadas": "BOLETAS FIRMADAS",
};

export default function Header() {
  const { user, role, managerCode, designation } = useAuth();
  const location = useLocation();

  const email = user?.email || "Usuario no identificado";

  let roleLabel = "Solo Visualizaciones";

  if (role === "admin") {
    roleLabel = "Administrador";
  } else if (role === "secretaria") {
    roleLabel = "Secretaría";
  } else if (role === "manager") {
    if (designation) {
      roleLabel = designation;
    } else if (managerCode) {
      const num = String(managerCode).replace("manager", "");
      roleLabel = `Manager ${num}`;
    } else {
      roleLabel = "Manager";
    }
  }

  const title =
    TITLES_BY_PATH[location.pathname] || "PORTAL DEL TRABAJADOR";

  const startOnboarding = () => window.dispatchEvent(new Event("onboarding:start"));

  return (
    <header className="header">
      <div className="header__center">
        <h1 className="header__title">{title}</h1>
      </div>

      <div className="header__right">
        <div className="header__actions">
          <button type="button" className="header__action-btn" aria-label="Notificaciones" title="Notificaciones">
            <FiBell />
          </button>
          <button type="button" className="header__action-btn" onClick={startOnboarding} aria-label="Abrir guía de esta pantalla" title="Abrir guía de esta pantalla">
            <FiHelpCircle />
          </button>
        </div>

        <div className="userbox">
          <div className="user-info">
            <div className="user-name" title={email}>
              {email}
            </div>
            <div className="user-role">{roleLabel}</div>
          </div>

          <div className="userbox__avatar">
            <img src="/avatar.jpg" alt="Avatar de usuario" />
          </div>
        </div>
      </div>
    </header>
  );
}
